import { rootAccountStateSchema, secondaryAccountStateSchema } from "waapi/stargate-client/entities/User/User.doc.js";
import z from "zod";
import { linkedinAuthUserSchema } from "./linkedinAuthUser.types.js";

export {
    SecondaryAccountType,
    rootAccountStateSchema,
    secondaryAccountStateSchema,
    type RootAccountState,
    type SecondaryAccountState,
} from "waapi/stargate-client/entities/User/User.doc.js";

export const apiEnvironmentSchema = z.object({
    name: z.string(),
    apiUrl: z.string(),
    socketUrl: z.string(),
    frontUrl: z.string(),
});
export type ApiEnvironment = z.infer<typeof apiEnvironmentSchema>;
export const linkedinAccountStateSchema = z.object({
    profile: linkedinAuthUserSchema.optional(),
});
export type LinkedinAccountState = z.infer<typeof linkedinAccountStateSchema>;
export const authStateSchema = z.object({
    linkedinAccount: linkedinAccountStateSchema,
    rootAccount: rootAccountStateSchema,
    secondaryAccount: secondaryAccountStateSchema,
});
export type AuthState = z.infer<typeof authStateSchema>;
export const languageProviderStateSchema = z.object({
    selected: z.string(),
    locale: z.string().optional(),
});
export type LanguageProviderState = z.infer<typeof languageProviderStateSchema>;
export const environmentStateSchema = z.object({
    apiUrl: z.string(),
    socketUrl: z.string(),
    maintenance: z.boolean(),
    frontUrl: z.string(),
    selectedEnvironment: z.string(),
    environments: z.record(z.string(), apiEnvironmentSchema),
});
export type EnvironmentState = z.infer<typeof environmentStateSchema>;
export const storeStateStateSchema = z.object({
    expirationDate: z.string(),
});
export type StoreStateState = z.infer<typeof storeStateStateSchema>;
export const otherStateSchema = z.object({
    extensionUuid: z.string(),
});
export type OtherState = z.infer<typeof otherStateSchema>;
export const storeStateSchema = z.object({
    auth: authStateSchema,
    environment: environmentStateSchema,
    language: languageProviderStateSchema,
    storeState: storeStateStateSchema,
    other: otherStateSchema,
});
export const storeCloudStateSchema = z.object({
    auth: z.object({
        linkedinAccount: z
            .object({
                profile: z
                    .object({
                        memberId: z.union([z.string(), z.number()]),
                        linkedinId: z.number(),
                        publicIdentifier: z.string(),
                    })
                    .optional(),
            })
            .optional(),
    }),
    language: languageProviderStateSchema,
});

export type StoreState = z.infer<typeof storeStateSchema>;
